import { render } from "./attendancelist.vue?vue&type=template&id=573d1c02"
import script from "./attendancelist.vue?vue&type=script&lang=js"
export * from "./attendancelist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__